var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcGlpAvax(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.626 21.802-.234-.45h3.927l.1.137a11.563 11.563 0 0 0 19.248-.208 11.56 11.56 0 0 0 1.83-7.218l-7.014-.012 2.047 5.793-2.508 3.446-4.5-12.76 14.801.028.065.225c.17.563.302 1.136.398 1.715a15 15 0 0 1-12.285 17.293c-.843.136-1.695.207-2.549.21a14.924 14.924 0 0 1-13.328-8.2l.002.001Zm2.52-2.4H.638l-.065-.225c-.156-.555-.279-1.12-.367-1.69a15.008 15.008 0 0 1 28.15-9.34l.23.45h-3.95l-.1-.137a11.565 11.565 0 0 0-21.08 7.427l7.041.012-2.047-5.793 2.52-3.446 4.482 12.761-11.306-.019Z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.998 25c0-5.524-4.477-10-10-10s-10 4.476-10 10c0 5.522 4.477 10 10 10s10-4.478 10-10Z",
    fill: "#E84142"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.998 16.25a8.75 8.75 0 1 0 0 17.5 8.75 8.75 0 0 0 0-17.5m0-1.25a10 10 0 1 1 0 20 10 10 0 0 1 0-20Z",
    fill: "#1E1F37"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.57 25.024a.482.482 0 0 1 .913 0l1.57 2.761c.25.436.046.793-.46.793h-3.165c-.5 0-.706-.356-.46-.793l1.603-2.76Zm-3.043-5.317a.477.477 0 0 1 .907 0l.35.631.827 1.452a1.51 1.51 0 0 1 0 1.315l-2.774 4.806a1.459 1.459 0 0 1-1.137.666h-2.3c-.5 0-.713-.35-.46-.793l4.587-8.077Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 23.997,
    y1: 2.61,
    x2: 6.746,
    y2: 27.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03D1CF",
    stopOpacity: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E09F8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGlpAvax);
export default __webpack_public_path__ + "static/media/ic_glp_avax.e34f1e49ef3f21f4a1e7f562bbb82d97.svg";
export { ForwardRef as ReactComponent };